import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-consult/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-consult/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-consult/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-consult/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-consult/detail',
    method: 'get',
    params: { id }
  })
}
export function putTop(params) {
  return request({
    url: '/cooking/cooking-consult/zd',
    method: 'get',
    params
  })
}
